export default "__VITE_ASSET__1a86f2c5__"